import { render, staticRenderFns } from "./HomePolicy.vue?vue&type=template&id=1e9f73d6&scoped=true&"
import script from "./HomePolicy.vue?vue&type=script&lang=js&"
export * from "./HomePolicy.vue?vue&type=script&lang=js&"
import style0 from "./HomePolicy.vue?vue&type=style&index=0&id=1e9f73d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f73d6",
  null
  
)

export default component.exports